export enum FEATURES_MANAGEMENT {
    /**
     * @value This feature is not included in your package
     */
    FEATURE_LOCK = 'ADMIN.FEATURE_MANAGEMENT.FEATURE_LOCK',
    /**
     * @value This feature requires additional license, please contact your LumApps Representative or Partners.
     */
    FEATURE_MESSAGE_CONTACT = 'FEATURES_MANAGEMENT.FEATURE_MESSAGE_CONTACT',
    /**
     * @value LumApps Packages page on The Hive Customers site
     */
    MESSAGE_DOC_LINK = 'ADMIN.FEATURE_MANAGEMENT.MESSAGE_DOC_LINK',
    /**
     * @value Only show available features
     */
    ONLY_SHOW_AVAILABLE_VALUE = 'ADMIN.FEATURE_MANAGEMENT.ONLY_SHOW_AVAILABLE_VALUE',
    PACKAGES_DOC_LINK = 'ADMIN.FEATURE_MANAGEMENT.PACKAGES_DOC_LINK',
    /**
     * @value Your company subscribed to the %PACKAGE% package.
     */
    PACKAGE_MESSAGE = 'FEATURES_MANAGEMENT.PACKAGE_MESSAGE',
    /**
     * @value For additional information, contact your LumApps Representative or Partners.
     */
    PACKAGE_MESSAGE_CONTACT = 'FEATURES_MANAGEMENT.PACKAGE_MESSAGE_CONTACT',
    /**
     * @value The platform has access to the %PACKAGE% package.
     */
    PACKAGE_MESSAGE_SUPPORT = 'ADMIN.FEATURE_MANAGEMENT.PACKAGE_MESSAGE_SUPPORT',
    /**
     * @value An error occurred while saving features, please try later
     * @description error message displayed when an error occurred when the user save features
     */
    SAVE_ERROR_UNKOWN = 'ADMIN.FEATURE_MANAGEMENT.SAVE_ERROR_UNKOWN',
    /**
     * @value Show only features available for my platform
     */
    SHOW_AVAILABLE_FEATURES = 'ADMIN.FEATURE_MANAGEMENT.SHOW_AVAILABLE_FEATURES',
    /**
     * @value Features Management
     */
    TITLE = 'ADMIN.FEATURES_MANAGEMENT.TITLE',
    /**
     * @value Check the spelling or try a different search term
     */
    TRY_NEW_SEARCH_TERM = 'ADMIN.FEATURES_MANAGEMENT.TRY_NEW_SEARCH_TERM',
}
